import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import TemplateDataTable from '../shared/TemplateDataTable';

export default function ReportingCtaTable({
  rows = [],
  isLoading,
  mode = 'org',
  emptyMessage = 'No CTA clicks recorded for this date range.',
}) {
  const orgColumns = useMemo(
    () => [
      { accessorKey: 'button_id', header: 'Button', enableSorting: false },
      { accessorKey: 'total_clicks', header: 'Total Clicks', enableSorting: true },
    ],
    []
  );

  const templateColumns = useMemo(
    () => [
      { accessorKey: 'label', header: 'Label', enableSorting: false },
      { accessorKey: 'type', header: 'Type', enableSorting: false },
      { accessorKey: 'totalClicks', header: 'Total Clicks', enableSorting: false },
      { accessorKey: 'clickRate', header: 'Click Rate', enableSorting: false },
    ],
    []
  );

  const columns = mode === 'template' ? templateColumns : orgColumns;

  if (isLoading) {
    return <Typography variant="body2">Loading CTA breakdown…</Typography>;
  }

  if (!rows.length) {
    return (
      <Box sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <TemplateDataTable
      columns={columns}
      data={rows}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnActions={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableBottomToolbar={mode === 'template' ? false : undefined}
      enablePagination={mode === 'template' ? false : undefined}
      renderTopToolbar={mode === 'template' ? false : undefined}
    />
  );
}
